import React, {FC} from "react"

import Link from "@irati/ui/src/Link"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"

interface Props extends InjectIntl {}

const LinkToFAQ: FC<Props> = ({formatMessage}) => {
  const link = (
    <Link href={formatMessage({id: "admin.reporting.orgSummary.linkToFAQ.href"})} target="_blank">
      {formatMessage({id: "admin.reporting.orgSummary.linkToFAQ.link"})}
    </Link>
  )

  return <FormattedMessage id="admin.reporting.orgSummary.linkToFAQ.text" values={{link}} />

}

export default injectIntl(LinkToFAQ)
